import {IAbstractModule, IModuleType} from "@/model/Locker/IModule";

export const ModuleZ2compA: IAbstractModule = {
  type: IModuleType.Z2comp,
  name: 'Z 2 compartment A',
  hasScreen: false,
  columns: [
    [
      {
        name: "1",
        connector: "1",
        cell_size_id: 1,
        accessible: false,
      },
      {
        name: "2",
        connector: "2",
        cell_size_id: 1,
        accessible: true,
      },
    ],
  ]
};
